interface IScalesHeightKpiTable {
  menuToggle: boolean
  isGraphic: boolean
  hasSessions: boolean
}

export const scalesHeightKpiTable = ({
  menuToggle,
  isGraphic,
  hasSessions
}: IScalesHeightKpiTable) => {
  if (menuToggle && isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 520px)'
    }
    return 'calc(100vh - 488px)'
  }

  if (!menuToggle && isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 661px)'
    }
    return 'calc(100vh - 629px)'
  }

  if (menuToggle && !isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 168px)'
    }
    return 'calc(100vh - 136px)'
  }

  if (!menuToggle && !isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 309px)'
    }
    return 'calc(100vh - 277px)'
  }
}
